import React from "react";
export const useUpdateEffect = (effect, deps) => {
    const didMount = React.useRef(false);
    React.useEffect(() => {
        if (didMount.current) {
            return effect();
        }
        didMount.current = true;
    }, deps);
};
